import { render, staticRenderFns } from "./menu-demo.vue?vue&type=template&id=8db22c04&"
import script from "./menu-demo.vue?vue&type=script&lang=ts&"
export * from "./menu-demo.vue?vue&type=script&lang=ts&"
import style0 from "./menu-demo.vue?vue&type=style&index=0&id=8db22c04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports